import React, {useContext, useMemo} from 'react';
import styles from "../styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import {CUSTOMER_SUPPORT} from "../../../../utils/i18nNameSpaces";
import {
  EmailMajor, ReceiptMajor, QuestionMarkMajor
} from '@shopify/polaris-icons';
import Button_action from "../../../common/elements/Button_action";
import {Icon, Tooltip} from "@shopify/polaris";
import {checkUsableCookie} from "../../../../helpers/cookie/checkUsableCookie";
import {COOKIE_ANALYTICS, COOKIE_FUNCTIONALITY, DEVIT_HELP_CENTER} from "../../../../utils/constants";
import {COOKIE_CONTEXT} from "../../../providers/CookieProvider";
import {useRouter} from "next/router";

const Index = ({t}) => {

  const {openBanner, openCookieToast, isBannerOpen} = useContext(COOKIE_CONTEXT);
  const router = useRouter();
  const bookACall = () => {
    if (!checkUsableCookie(COOKIE_FUNCTIONALITY)) {
      if (isBannerOpen) {
        openCookieToast(COOKIE_FUNCTIONALITY)
      }
      openBanner([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS]);
      return;
    }
    window.__supportBookACall && window.__supportBookACall()
    return false;
  }

  const webCall = () => {
    if (!checkUsableCookie(COOKIE_FUNCTIONALITY)) {
      if (isBannerOpen) {
        openCookieToast(COOKIE_FUNCTIONALITY)
      }
      openBanner([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS]);
      return;
    }
    window.__supportWebCall && window.__supportWebCall()
    return false;
  }

  const help = () => {
    window.open(DEVIT_HELP_CENTER, '_ blank');
    return false;
  }

  const funcList = [
    bookACall,
    webCall,
    help,
  ]

  const showCards = useMemo(() => {
    const data = t("cards", {}, {returnObjects: true});

    const images = [
      EmailMajor,
      ReceiptMajor,
      QuestionMarkMajor
    ]
    return (
      <ul className={styles["cards-list"]}>
        {data.map((el, i) => (
          <li key={i} className={styles["card"]}>
            <div className={styles["icon-wrapper"]}>
              <Icon source={images[i]} color={"base"}/>
            </div>
            <div className={styles["card-content"]}>
              <div>
                <p className={styles["card-header"]}>{el.header}</p>
                <p className={styles["card-text"]}>{el.text}</p>
              </div>
              <Button_action onClick={funcList[i]}>{el.btn}</Button_action>
            </div>
          </li>
        ))}
      </ul>
    )
  }, [t])

  return (
    <div className={styles["cards"]}>
      <div className={styles["cards-container"]}>
        {showCards}
      </div>
    </div>
  );
};

export default Index;